import { ButtonProps, Button } from 'antd'

const ActionButton: React.FC<Pick<ButtonProps, 'onClick' | 'disabled'>> = ({
  onClick,
  children,
  disabled,
}) => (
  <Button
    disabled={disabled}
    style={{
      whiteSpace: 'normal',
      padding: 0,
      margin: 0,
      display: 'inline-flex',
    }}
    type="link"
    onClick={onClick}
  >
    {children}
  </Button>
)

export default ActionButton
